<template>
    <div class="positionRelative">
        <LoadingOverlay v-if="isLoading" />
        <ContactForm @submitContactForm="submit"/>
    </div>
</template>

<script>
    import ContactForm from "../components/ContactForm";
    import _ from 'lodash';

    export default {
        name: "Contact",
        components: {ContactForm},
        store : ['registration', 'currentView'],

        methods : {
            submit (data) {
                _.each(data, (value, key) => {
                   if(_.has(this.registration, key)) {
                       _.set(this.registration, key, value);
                   }
                });
                if(window.sessionStorage) {
                    let temp = _.cloneDeep(this.registration);
                    _.unset(temp, 'password');
                    window.sessionStorage.setItem('registration', JSON.stringify(temp));
                }

                this.currentView = 'beers';
                
                // Using Api.post to send data
                /** Commented by Franz 27mar2024 as it caused an error in the console
                console.log('calling /registrations data:', data);
                Api.post(`/registrations`, data).then(response => {
                    console.log('Registration data submitted successfully', response);
                }).catch(error => {
                    console.error('Error submitting registration data', error);
                }); */

            },
            
        },

        data () {
            return {
                isLoading: false,
            }
        },
    }
</script>

<style scoped>

</style>